import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorMasterCountrySearch = () => {
  const countrySearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/management/master-country/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])

  return { countrySearch }
}

export default InteractorMasterCountrySearch
